import api from '@/api'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'
import { mapGetters } from 'vuex'

import TagManagement from '@/components/view/ticket/TagManagement'
export default {
  props: {
    value: {
      default: null
    },
    loading: {
      default: false
    },
    livechat: {
      default: false
    },
    type: {
      default: 'edit'
    }
  },
  components: {
    Multiselect,
    datepicker,
    TagManagement
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      ticketTags: 'ticketTags',
      ticketTagsFull: 'ticketTagsFull',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    }),
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    filterAgents() {
      if (this.ticket.group) {
        var agents = this.agents.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
        if (this.ticket.subgroup) {
          agents = agents.filter((el) => {
            return el.adminsubgroupid == this.ticket.subgroup.id
          })
        }
        return agents
      } else {
        return this.agents ? this.agents : []
      }
    }
  },
  data() {
    return {
      timestamp: moment().format('x'),
      ticket: {
        userid: null,
        firstname: null,
        lastname: null,
        group: null,
        subgroup: null,
        subject: null,
        details: null,
        assignedTo: null,
        channel: null,
        status: 'pending',
        priority: null,
        duedate: null,
        tags: null,
        contact_firstname: null,
        contact_lastname: null,
        contact_salary: null,
        contact_occupation: null,
        contact_phone: null,
        contact_email: null
      },
      statusOptions: [
        'open',
        'pending',
        'answered',
        'closed',
        'cancelled',
        'cancelled by customer'
      ],

      showManage: false,
      search: '',
      loadingTicket: false,
      items: [],
      select: null,
      groupOptions: [],
      subGroupOptions: [],
      tags: [],
      tagssearch: null,
      tagitems: [{ header: 'Select an option or create one' }],
      tagediting: null,

      priority: {
        text: 'Medium',
        value: 'medium'
      },
      priorityOptions: [
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      appOptions: ['', 'phone', 'email', 'website', 'others'],

      duedate: {
        start: null,
        starttime: null
      },

      showDueDate: false,
      showDueTimeDialog: false,
      isDirtyTagManagement: false
    }
  },
  async mounted() {
    // if(livechat) {
    //   await this.$store.dispatch('loadAgentGroups')
    //   await this.$store.dispatch('loadAgentSubGroups')
    //   await this.$store.dispatch('loadAgents')
    // }

    if (this.value) {
      this.ticket = {
        ...this.value,
        id: this.value.id,
        userid: this.value.userid,
        firstname: this.value.first_name,
        lastname: this.value.last_name,
        group: null,
        subgroup: null,
        subject: this.value.subject,
        details: this.value.details,
        assignedTo: null,
        channel: this.value.channel,
        status: this.value.status,
        priority: this.value.priority,
        duedate: this.value.duedate,
        tags: this.value.tags,
        contact_firstname: this.value.contact_firstname,
        contact_lastname: this.value.contact_lastname,
        contact_phone: this.value.contact_phone,
        contact_email: this.value.contact_email
      }
      if (this.value.duedate) {
        this.duedate.start = this.value.duedate
        this.duedate.starttime = moment(this.value.duedate).format('HH:mm')
      }

      if (this.value.assigngroupid) {
        var group = this.agentGroup.find((el) => {
          return el.id == this.value.assigngroupid
        })
        if (group) this.$set(this.ticket, 'group', group)
      }

      if (this.value.assignsubgroupid) {
        var subgroup = this.agentSubGroup.find((el) => {
          return el.id == this.value.assignsubgroupid
        })

        if (subgroup) this.$set(this.ticket, 'subgroup', subgroup)
      }
      if (this.value.assignadminid) {
        var agent =
          this.agents && this.agents.length
            ? this.agents.find((el) => {
                return el.adminid == this.value.assignadminid
              })
            : undefined
        if (agent) this.$set(this.ticket, 'assignedTo', agent)
      }

      if (this.value.priority) {
        this.priority = this.priorityOptions.find((el) => {
          return el.value == this.value.priority
        })
      }

      try {
        if (this.value.tags) {
          var tags = this.value.tags.split(',')
          this.tags = tags.map((el) => {
            return { name: el }
          })
        }
      } catch (error) {}
      //   if (this.value.assignAdminId) {
      //     var agents = this.agents.find(el => {
      //       return el.adminid == this.value.assignAdminId
      //     })
      //     if (agents) this.$set(this.ticket, 'assignedTo', agents)
      //   }
    } else {
      var group = this.agentGroup.find((el) => {
        return el.groupname == 'Agent'
      })
      // console.log(this.value);
      if (group) this.$set(this.ticket, 'group', group)
    }

    this.cached_ticket = JSON.stringify(this.ticket)

    await this.$nextTick()
    this.timestamp = moment().format('x')
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    tags(val, prev) {
      if (val.length === prev.length) return

      this.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            name: v
          }

          this.tagitems.push(v)
        }

        return v
      })
    }
  },
  methods: {
    handleTagDirty() {
      this.isDirtyTagManagement = true
    },
    checkObject(item) {
      return typeof item !== 'object'
    },
    onAssignInput(val) {
      if (val) {
        this.ticket.group = this.agentGroup.find((el) => el.id == val.admingroupid)
        this.ticket.subgroup = this.agentSubGroup.find((el) => el.id == val.adminsubgroupid)
      }
    },
    onSelectedDueDate: function (value) {
      var vm = this

      if (moment(this.duedate.end).isBefore(value)) {
        this.duedate.end = value
      }
      vm.duedate.start = value
      vm.showDueDate = false
    },
    async onChangeGroup(val) {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },

    async onChangeSubGroup(val) {
      this.ticket.assignedTo = null
    },
    async openModal() {
      this.showManage = true
      this.loadingTicket = true
      await this.$store.dispatch('getTicketTags')
      this.items = await this.getLoadUsers()
      this.loadingTicket = false
    },
    saveTicket(data) {
      return new Promise((resolve, reject) => {
        var request = data

        api.ticket2CommonCreateTicket(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editTicket(data) {
      return new Promise((resolve, reject) => {
        var request = data
        api.ticket2CommonUpdateTicket(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    onCancel() {
      this.showManage = false
      this.ticket = JSON.parse(this.cached_ticket)
      this.select = null
    },
    addUserManual(data) {
      return new Promise((resolve, reject) => {
        var request = data
        api.postUsersmanual(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editUserManual(data) {
      return new Promise((resolve, reject) => {
        var request = {
          data: data,
          params: {
            pageid: data.pageid,
            userid: data.userid
          }
        }
        api.putUsersmanual(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onSave() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loadingTicket = true
      try {
        const currentTags = this.tags.map((el) => {
          return el.name
        })
        var data = {}
        if (this.type == 'add') {
          if (!this.ticket.userid) {
            var request = {
              ...this.ticket,
              pageid: this.selectedBot.pageid,
              first_name: this.ticket.firstname,
              last_name: this.ticket.lastname,
              gender: this.ticket.gender,
              app: this.ticket.app,
              channel: this.ticket.channel,
              email: this.ticket.email,
              phoneno: this.ticket.contact_phone,
              address: this.ticket.contact_email
            }
            var responseUser = await this.addUserManual(request)
            if (responseUser.data && responseUser.data.length > 0) {
              this.$set(this.ticket, 'userid', responseUser.data[0].id)
            }
          }

          if (this.ticket.userid) {
            data = {
              ...this.ticket,
              pageid: this.selectedBot.pageid,
              userid: this.ticket.userid,
              subject: this.ticket.subject,

              details: this.ticket.details,
              channel: this.ticket.channel,
              status: this.ticket.status,
              assignGroupId: this.ticket.group ? this.ticket.group.id : null,
              assignSubGroupId: this.ticket.subgroup ? this.ticket.subgroup.id : null,
              assignAdminId: this.ticket.assignedTo ? this.ticket.assignedTo.adminid : null,

              priority: this.priority.value,
              duedate: this.duedate.start
                ? moment(this.duedate.start).format('YYYY-MM-DD ') +
                  (this.duedate.starttime ? this.duedate.starttime : '00:00')
                : null,
              tags: currentTags.join(',')
            }
            var responseTicket = await this.saveTicket(data)
            if (responseTicket.data && responseTicket.data.length > 0)
              this.$emit('addTicket', responseTicket.data[0])
          }
        } else {
          var request = {
            ...this.ticket,
            userid: this.ticket.userid,
            pageid: this.selectedBot.pageid,
            first_name: this.ticket.firstname,
            last_name: this.ticket.lastname,
            email: this.ticket.email,
            phoneno: this.ticket.phoneno,
            address: this.ticket.address
          }
          if (!this.livechat && false) {
            var responseUser = await this.editUserManual(request)
          }
          data = {
            pageid: this.selectedBot.pageid, // required
            ticketId: this.ticket.id, // required
            priority: this.priority.value,
            status: this.ticket.status,
            subject: this.ticket.subject,
            details: this.ticket.details,
            contact_firstname: this.ticket.contact_firstname,
            contact_lastname: this.ticket.contact_lastname,
            contact_email: this.ticket.contact_email,
            contact_phone: this.ticket.contact_phone,
            tags: currentTags.join(',')
          }

          if (this.ticket.group) {
            if (this.ticket.group) {
              Object.assign(data, { assigngroupid: this.ticket.group.id })
            }
            if (this.ticket.subgroup) {
              Object.assign(data, { assignsubgroupid: this.ticket.subgroup.id })
            }
            if (this.ticket.assignedTo) {
              Object.assign(data, { assignadminid: this.ticket.assignedTo.adminid })
            }

            // var responseTransfer = await this.onTransferTicket()

            // if (responseTransfer.responsecode == 200) {
            var responseTicket = await this.editTicket(data)
            if (responseTicket.responsecode == 200) {
              this.$emit('editTicket', data)
              // }
            }
          } else {
            var responseTicket = await this.editTicket(data)
            if (responseTicket.responsecode == 200) {
              this.$emit('editTicket', data)
            }
          }
        }

        if (this.selectedBot.theme == 'toa') {
          this.$store.dispatch('updateTicketTags', currentTags)
          if (this.isDirtyTagManagement) {
            await this.$store.dispatch('getTicketTags', true)
          }
        }

        this.showManage = false
        this.cached_ticket = JSON.stringify(this.ticket)
        this.select = null
      } catch (error) {
        console.error(error)
      }
      this.loadingTicket = false
    },
    async onTransferTicket() {
      return new Promise((resolve, reject) => {
        var data = {
          pageid: this.selectedBot.pageid,
          transferGroupId: this.ticket.group.id,
          ticketId: this.ticket.id
        }
        if (this.ticket.subgroup) {
          Object.assign(data, { transferSubGroupId: this.ticket.subgroup.id })
        }
        if (this.ticket.assignedTo) {
          Object.assign(data, { transferAdminId: this.ticket.assignedTo.adminid })
        }

        api.ticket2CommonTransferTicket(data, (err, response) => {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      })
    },
    onChangeSelect(val) {
      if (val) {
        this.$set(this.ticket, 'userid', val.id)
        this.$set(this.ticket, 'contact_firstname', val.first_name)
        this.$set(this.ticket, 'contact_lastname', val.last_name)
        this.$set(this.ticket, 'contact_email', val.email)
        this.$set(this.ticket, 'contact_phoneno', val.phoneno)
        this.$set(this.ticket, 'channel', val.channel)
      }
    },
    onClearCustomer() {
      this.select = null
      this.$set(this.ticket, 'userid', null)
      this.$set(this.ticket, 'contact_firstname', null)
      this.$set(this.ticket, 'contact_lastname', null)
      this.$set(this.ticket, 'contact_email', null)
      this.$set(this.ticket, 'contact_phoneno', null)
      this.$set(this.ticket, 'channel', null)
    },
    async querySelections(v) {
      this.loadingTicket = true
      var search = (v || '').toLowerCase()
      this.items = await this.getLoadUsers()
      this.loadingTicket = false
    },
    getLoadUsers: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          filter: {
            fullname: vm.search
          },
          limit: 100,
          offset: 0
        }

        api.getAllUsers(data, function (error, response) {
          if (error) {
            reject(error)
          }

          var users = response.data
          resolve(users)
        })
      })
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    getFullName(item) {
      return [item.first_name, item.last_name].join(' ')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/toa/management/TicketEdit.js